export enum EnvironmentTypes {
  dev = 'https://customercare-dev.azureedge.net/',
  qas = 'https://customercare-qa.azureedge.net/'
}